import sittingDogStickerSrc from '../assets/stickers/sitting-dog.svg'
import rainbowStickerSrc from '../assets/stickers/rainbow.svg'
import hiTextStickerSrc from '../assets/stickers/hi-text.svg'
import smileyDaisyStickerSrc from '../assets/stickers/smiley-daisy.svg'
import rollerSkateCatStickerSrc from '../assets/stickers/roller-skate-cat.svg'
import smileyHeartWithRainbowTailStickerSrc from '../assets/stickers/smiley-heart-with-rainbow-tail.svg'
import donutHeartStickerSrc from '../assets/stickers/donut-heart.svg'
import heartSunglassesStickerSrc from '../assets/stickers/heart-sunglasses.svg'
import starWithRainbowTrailStickerSrc from '../assets/stickers/star-with-rainbow-trail.svg'
import pinkSmileyFlowerStickerSrc from '../assets/stickers/pink-smiley-flower.svg'
import heartWithTrailsStickerSrc from '../assets/stickers/heart-with-trails.svg'
import purpleFlowerStickerSrc from '../assets/stickers/purple-flower.svg'
import yellowDaisyStickerSrc from '../assets/stickers/yellow-daisy.svg'
import pinkFlowerStickerSrc from '../assets/stickers/pink-flower.svg'
import cartoonRockHandSignStickerSrc from '../assets/stickers/cartoon-rock-hand-sign.svg'
import lemonBranchStickerSrc from '../assets/stickers/lemon-branch.svg'
import pinkHangingFlowerStickerSrc from '../assets/stickers/pink-hanging-flower.svg'
import withLoveTextStickerSrc from '../assets/stickers/with-love-text.svg'
import blueMugStickerSrc from '../assets/stickers/blue-mug.svg'
import blackLeafBranchStickerSrc from '../assets/stickers/black-leaf-branch.svg'
import blackMonsteraLeafStickerSrc from '../assets/stickers/black-monstera-leaf.svg'
import stackedBooksStickerSrc from '../assets/stickers/stacked-books.svg'
import blueCandleStickerSrc from '../assets/stickers/blue-candle.svg'
import fireFlameStickerSrc from '../assets/stickers/fire-flame.svg'
import blueCactusPotStickerSrc from '../assets/stickers/blue-cactus-pot.svg'
import pizzaSliceStickerSrc from '../assets/stickers/pizza-slice.svg'
import heartSpeechBubbleStickerSrc from '../assets/stickers/heart-speech-bubble.svg'
import cartoonPeaceHandSignStickerSrc from '../assets/stickers/cartoon-peace-hand-sign.svg'
import grayscaleRingedPlanetStickerSrc from '../assets/stickers/grayscale-ringed-planet.svg'
import splitBananaLeafStickerSrc from '../assets/stickers/split-banana-leaf.svg'
import roundSunglassesStickerSrc from '../assets/stickers/round-sunglasses.svg'
import flamingoStickerSrc from '../assets/stickers/flamingo.svg'
import jungleMonsteraLeafStickerSrc from '../assets/stickers/jungle-monstera-leaf.svg'
import pinkConchShellStickerSrc from '../assets/stickers/pink-conch-shell.svg'
import pinkBeachUmbrellaStickerSrc from '../assets/stickers/pink-beach-umbrella.svg'
import pinkScallopShellStickerSrc from '../assets/stickers/pink-scallop-shell.svg'
import pinkAnchorStickerSrc from '../assets/stickers/pink-anchor.svg'
import orangeSnorkelStickerSrc from '../assets/stickers/orange-snorkel.svg'
import slimBananaLeafStickerSrc from '../assets/stickers/slim-banana-leaf.svg'
import surfboardWithFlamesStickerSrc from '../assets/stickers/surfboard-with-flames.svg'
import greenBinocularsStickerSrc from '../assets/stickers/green-binoculars.svg'
import maroonTravelSuitcaseStickerSrc from '../assets/stickers/maroon-travel-suitcase.svg'
import popsicleStickerSrc from '../assets/stickers/popsicle.svg'
import watermelonSliceStickerSrc from '../assets/stickers/watermelon-slice.svg'
import palmLeafStickerSrc from '../assets/stickers/palm-leaf.svg'
import goldOrnateDividerStickerSrc from '../assets/stickers/gold-ornate-divider.svg'
import goldArrowDividerStickerSrc from '../assets/stickers/gold-arrow-divider.svg'
import goldStarIconStickerSrc from '../assets/stickers/gold-star-icon.svg'
import whiteOrnateDividerStickerSrc from '../assets/stickers/white-ornate-divider.svg'

export const STICKER_OPTIONS = [
  {
    id: 'sitting-dog',
    labelKey: 'Sticker.sittingDog.label',
    defaultLabel: 'Sitting Dog',
    src: sittingDogStickerSrc,
    width: 68,
    height: 58,
  },
  {
    id: 'rainbow',
    labelKey: 'Sticker.rainbow.label',
    defaultLabel: 'Rainbow',
    src: rainbowStickerSrc,
    width: 78.65,
    height: 63.5,
  },
  {
    id: 'hi-text',
    labelKey: 'Sticker.hiText.label',
    defaultLabel: 'Hi Text',
    src: hiTextStickerSrc,
    width: 60,
    height: 50,
  },
  {
    id: 'smiley-daisy',
    labelKey: 'Sticker.smileyDaisy.label',
    defaultLabel: 'Smiley Daisy',
    src: smileyDaisyStickerSrc,
    width: 68,
    height: 68,
  },
  {
    id: 'roller-skate-cat',
    labelKey: 'Sticker.rollerSkateCat.label',
    defaultLabel: 'Roller Skate Cat',
    src: rollerSkateCatStickerSrc,
    width: 48,
    height: 65,
  },
  {
    id: 'smiley-heart-with-rainbow-tail',
    labelKey: 'Sticker.smileyHeartWithRainbowTail.label',
    defaultLabel: 'Smiley Heart with Rainbow Tail',
    src: smileyHeartWithRainbowTailStickerSrc,
    width: 49,
    height: 47,
  },
  {
    id: 'donut-heart',
    labelKey: 'Sticker.donutHeart.label',
    defaultLabel: 'Donut Heart',
    src: donutHeartStickerSrc,
    width: 60,
    height: 53,
  },
  {
    id: 'heart-sunglasses',
    labelKey: 'Sticker.heartSunglasses.label',
    defaultLabel: 'Heart Sunglasses',
    src: heartSunglassesStickerSrc,
    width: 60,
    height: 45,
  },
  {
    id: 'star-with-rainbow-trail',
    labelKey: 'Sticker.starWithRainbowTrail.label',
    defaultLabel: 'Star with Rainbow Trail',
    src: starWithRainbowTrailStickerSrc,
    width: 68,
    height: 52,
  },
  {
    id: 'pink-smiley-flower',
    labelKey: 'Sticker.pinkSmileyFlower.label',
    defaultLabel: 'Pink Smiley Flower',
    src: pinkSmileyFlowerStickerSrc,
    width: 63,
    height: 59,
  },
  {
    id: 'heart-with-trails',
    labelKey: 'Sticker.heartWithTrails.label',
    defaultLabel: 'Heart with Trails',
    src: heartWithTrailsStickerSrc,
    width: 87,
    height: 60,
  },
  {
    id: 'purple-flower',
    labelKey: 'Sticker.purpleFlower.label',
    defaultLabel: 'Purple Flower',
    src: purpleFlowerStickerSrc,
    width: 48,
    height: 48,
  },
  {
    id: 'yellow-daisy',
    labelKey: 'Sticker.yellowDaisy.label',
    defaultLabel: 'Yellow Daisy',
    src: yellowDaisyStickerSrc,
    width: 46.5,
    height: 55,
  },
  {
    id: 'pink-flower',
    labelKey: 'Sticker.pinkFlower.label',
    defaultLabel: 'Pink Flower',
    src: pinkFlowerStickerSrc,
    width: 47,
    height: 50,
  },
  {
    id: 'cartoon-rock-hand-sign',
    labelKey: 'Sticker.cartoonRockHandSign.label',
    defaultLabel: 'Cartoon Rock Hand Sign',
    src: cartoonRockHandSignStickerSrc,
    width: 42,
    height: 88,
  },
  {
    id: 'lemon-branch',
    labelKey: 'Sticker.lemonBranch.label',
    defaultLabel: 'Lemon Branch',
    src: lemonBranchStickerSrc,
    width: 58,
    height: 70,
  },
  {
    id: 'hanging-flower-with-pink-petals',
    labelKey: 'Sticker.pinkHangingFlower.label',
    defaultLabel: 'Pink Hanging Flower',
    src: pinkHangingFlowerStickerSrc,
    width: 30,
    height: 28,
  },
  {
    id: 'with-love-text',
    labelKey: 'Sticker.withLoveText.label',
    defaultLabel: 'With Love Text',
    src: withLoveTextStickerSrc,
    width: 41,
    height: 50,
  },
  {
    id: 'blue-mug',
    labelKey: 'Sticker.blueMug.label',
    defaultLabel: 'Blue Mug',
    src: blueMugStickerSrc,
    width: 67,
    height: 66,
  },
  {
    id: 'black-leaf-branch',
    labelKey: 'Sticker.blackLeafBranch.label',
    defaultLabel: 'Black Leaf Branch',
    src: blackLeafBranchStickerSrc,
    width: 48,
    height: 58,
  },
  {
    id: 'black-monstera-leaf',
    labelKey: 'Sticker.blackMonsteraLeaf.label',
    defaultLabel: 'Black Monstera Leaf',
    src: blackMonsteraLeafStickerSrc,
    width: 48,
    height: 54,
  },
  {
    id: 'stacked-books',
    labelKey: 'Sticker.stackedBooks.label',
    defaultLabel: 'Stacked Books',
    src: stackedBooksStickerSrc,
    width: 57,
    height: 84,
  },
  {
    id: 'blue-candle',
    labelKey: 'Sticker.blueCandle.label',
    defaultLabel: 'Blue Candle',
    src: blueCandleStickerSrc,
    width: 42,
    height: 48,
  },
  {
    id: 'fire-flame',
    labelKey: 'Sticker.fireFlame.label',
    defaultLabel: 'Fire Flame',
    src: fireFlameStickerSrc,
    width: 49,
    height: 61,
  },
  {
    id: 'blue-cactus-pot',
    labelKey: 'Sticker.blueCactusPot.label',
    defaultLabel: 'Blue Cactus Pot',
    src: blueCactusPotStickerSrc,
    width: 48,
    height: 72,
  },
  {
    id: 'pizza-slice',
    labelKey: 'Sticker.pizzaSlice.label',
    defaultLabel: 'Pizza Slice',
    src: pizzaSliceStickerSrc,
    width: 48,
    height: 52,
  },
  {
    id: 'heart-speech-bubble',
    labelKey: 'Sticker.heartSpeechBubble.label',
    defaultLabel: 'Heart Speech Bubble',
    src: heartSpeechBubbleStickerSrc,
    width: 58,
    height: 49,
  },
  {
    id: 'cartoon-peace-hand-sign',
    labelKey: 'Sticker.cartoonPeaceHandSign.label',
    defaultLabel: 'Cartoon Peace Hand Sign',
    src: cartoonPeaceHandSignStickerSrc,
    width: 48,
    height: 42,
  },
  {
    id: 'grayscale-ringed-planet',
    labelKey: 'Sticker.grayscaleRingedPlanet.label',
    defaultLabel: 'Grayscale Ringed Planet',
    src: grayscaleRingedPlanetStickerSrc,
    width: 48,
    height: 53,
  },
  {
    id: 'split-banana-leaf',
    labelKey: 'Sticker.splitBananaLeaf.label',
    defaultLabel: 'Split Banana Leaf',
    src: splitBananaLeafStickerSrc,
    width: 84.5,
    height: 75,
  },
  {
    id: 'round-sunglasses',
    labelKey: 'Sticker.roundSunglasses.label',
    defaultLabel: 'Round Sunglasses',
    src: roundSunglassesStickerSrc,
    width: 84.5,
    height: 35,
  },
  {
    id: 'flamingo',
    labelKey: 'Sticker.flamingo.label',
    defaultLabel: 'Flamingo',
    src: flamingoStickerSrc,
    width: 68,
    height: 60,
  },
  {
    id: 'jungle-monstera-leaf',
    labelKey: 'Sticker.jungleMonsteraLeaf.label',
    defaultLabel: 'Jungle Monstera Leaf',
    src: jungleMonsteraLeafStickerSrc,
    width: 85,
    height: 60,
  },
  {
    id: 'pink-conch-shell',
    labelKey: 'Sticker.pinkConchShell.label',
    defaultLabel: 'Pink Conch Shell',
    src: pinkConchShellStickerSrc,
    width: 47,
    height: 46,
  },
  {
    id: 'pink-beach-umbrella',
    labelKey: 'Sticker.pinkBeachUmbrella.label',
    defaultLabel: 'Pink Beach Umbrella',
    src: pinkBeachUmbrellaStickerSrc,
    width: 56.5,
    height: 69,
  },
  {
    id: 'pink-scallop-shell',
    labelKey: 'Sticker.pinkScallopShell.label',
    defaultLabel: 'Pink Scallop Shell',
    src: pinkScallopShellStickerSrc,
    width: 50,
    height: 51,
  },
  {
    id: 'pink-anchor',
    labelKey: 'Sticker.pinkAnchor.label',
    defaultLabel: 'Pink Anchor',
    src: pinkAnchorStickerSrc,
    width: 47,
    height: 51,
  },
  {
    id: 'orange-snorkel',
    labelKey: 'Sticker.orangeSnorkel.label',
    defaultLabel: 'Orange Snorkel',
    src: orangeSnorkelStickerSrc,
    width: 79,
    height: 60,
  },
  {
    id: 'slim-banana-leaf',
    labelKey: 'Sticker.slimBananaLeaf.label',
    defaultLabel: 'Slim Banana Leaf',
    src: slimBananaLeafStickerSrc,
    width: 120,
    height: 60,
  },
  {
    id: 'surfboard-with-flames',
    labelKey: 'Sticker.surfboardWithFlames.label',
    defaultLabel: 'Surfboard with Flames',
    src: surfboardWithFlamesStickerSrc,
    width: 25,
    height: 80,
  },
  {
    id: 'green-binoculars',
    labelKey: 'Sticker.greenBinoculars.label',
    defaultLabel: 'Green Binoculars',
    src: greenBinocularsStickerSrc,
    width: 57,
    height: 48,
  },
  {
    id: 'maroon-travel-suitcase',
    labelKey: 'Sticker.maroonTravelSuitcase.label',
    defaultLabel: 'Maroon Travel Suitcase',
    src: maroonTravelSuitcaseStickerSrc,
    width: 60,
    height: 48,
  },
  {
    id: 'popsicle',
    labelKey: 'Sticker.popsicle.label',
    defaultLabel: 'Popsicle',
    src: popsicleStickerSrc,
    width: 19,
    height: 80,
  },
  {
    id: 'watermelon-slice',
    labelKey: 'Sticker.watermelonSlice.label',
    defaultLabel: 'Watermelon Slice',
    src: watermelonSliceStickerSrc,
    width: 56,
    height: 52,
  },
  {
    id: 'palm-leaf',
    labelKey: 'Sticker.palmLeaf.label',
    defaultLabel: 'Palm Leaf',
    src: palmLeafStickerSrc,
    width: 96,
    height: 70,
  },
  {
    id: 'gold-ornate-divider',
    labelKey: 'Sticker.goldOrnateDivider.label',
    defaultLabel: 'Gold Ornate Divider',
    src: goldOrnateDividerStickerSrc,
    width: 443,
    height: 25,
  },
  {
    id: 'gold-arrow-divider',
    labelKey: 'Sticker.goldArrowDivider.label',
    defaultLabel: 'Gold Arrow Divider',
    src: goldArrowDividerStickerSrc,
    width: 287,
    height: 25,
  },
  {
    id: 'gold-star-icon',
    labelKey: 'Sticker.goldStarIcon.label',
    defaultLabel: 'Gold Star Icon',
    src: goldStarIconStickerSrc,
    width: 48,
    height: 52,
  },
  {
    id: 'white-ornate-divider',
    labelKey: 'Sticker.whiteOrnateDivider.label',
    defaultLabel: 'White Ornate Divider',
    src: whiteOrnateDividerStickerSrc,
    width: 443,
    height: 25,
    previewStyles: {
      background: '#444',
      padding: 8,
    },
  },
]

export const STICKER_OPTION_BY_ID = STICKER_OPTIONS.reduce((accumulator, option) => {
  accumulator[option.id] = option
  return accumulator
}, {})
